module.exports = __webpack_public_path__ + "static/media/NRV-BNB.624c1a76.svg";